import React, {useState, useEffect} from "react";
import Api from "../../interface/api/site";

export default function SiteSelect() {
    const  [ modal, setModal ] = useState<boolean>(false);

    function closeModalHandler() {
        setModal(false)
    }

    return (
        <>
            <button
                type="button"
                className="nv_green_button"
                style={{lineHeight: '0px', margin: '22.5px 20px 22.5px 0', backgroundColor: '#00a99d'}}
                onClick={() => setModal(true)}>
                사업장변경
            </button>
            {
                modal && <Modal
                    closeModalHandler={closeModalHandler} />
            }
        </>
    )
}

function Modal({closeModalHandler}) {

    const [ site1, setSite1 ] = useState<Array<any>>([]);
    const [ site2, setSite2 ] = useState<Array<any>>([]);
    const [ site3, setSite3 ] = useState<Array<any>>([]);
    const [ site4, setSite4 ] = useState<Array<any>>([]);
    const [ selectSiteInfo, setSelectSiteInfo ] = useState<Array<any>>([]);

    useEffect(() => {
        Api.siteInfoList().then(res => {
            for(let i =0; i< res.data.length; i++) {
                if(i==0) {
                    setSite1(res.data[i].childrenSiteInfos)
                }
                if(i==1) {
                    setSite2(res.data[i].childrenSiteInfos)
                }
                if(i==2) {
                    setSite3(res.data[i].childrenSiteInfos)
                }
                if(i==3) {
                    setSite4(res.data[i].childrenSiteInfos)
                }
            }
        });
    }, [])

    function changeSiteInfoHandler() {
        if( localStorage.getItem('siteInfo') === null ) {
            alert('사업장을 선택해주세요.');
            return false;
        }
        localStorage.setItem('siteInfo', JSON.stringify(selectSiteInfo));
        let _hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        _hostInfo.siteInfo = selectSiteInfo;
        localStorage.setItem('hostInfo', JSON.stringify(_hostInfo));
        closeModalHandler();
    }

    return (
        <div className="nv_modal site_select_modal on">
            <div className="nv_modal_container">
                <div className="nv_modal_header">
                    <h2>사업장 변경</h2>
                    <p className="nv_modal_close" onClick={closeModalHandler}>닫기</p>
                </div>
                <div className="nv_modal_contents">
                    <div className="nv_site">
                        <p className="nv_en">GONGJU</p>
                        <h2 className="nv_name">공주공장</h2>
                        <div className="site_select_wrap">
                            <div className="site_select">
                                <p className="selectTit">선택</p>
                                <ul>
                                    {
                                        site1.map((row2) => (
                                            row2.name !== 'FECT' ?
                                                <li onClick={() => setSelectSiteInfo(row2)}>{row2.name}</li>
                                                : ''
                                        ))
                                    }
                                </ul>
                            </div>
                            <button type="button" className="btn_gate" onClick={changeSiteInfoHandler}>선택
                            </button>
                        </div>
                    </div>
                    <div className="nv_site">
                        <p className="nv_en">PAJU</p>
                        <h2 className="nv_name">파주공장</h2>
                        <div className="site_select_wrap">
                            <div className="site_select">
                                <p className="selectTit">선택</p>
                                <ul>
                                    {
                                        site2.map((row2) => (
                                            <li onClick={() => setSelectSiteInfo(row2)}>{row2.name}</li>
                                        ))
                                    }
                                </ul>
                            </div>
                            <button type="button" className="btn_gate" onClick={changeSiteInfoHandler}>선택
                            </button>
                        </div>
                    </div>
                    <div className="nv_site">
                        <p className="nv_en">PANKYO</p>
                        <h2 className="nv_name">판교중앙연구소</h2>
                        <div className="site_select_wrap">
                            <div className="site_select">
                                <p className="selectTit">선택</p>
                                <ul>
                                    {
                                        site4.map((row2) => (
                                            <li onClick={() => setSelectSiteInfo(row2)}>{row2.name}</li>
                                        ))
                                    }
                                </ul>
                            </div>
                            <button type="button" className="btn_gate" onClick={changeSiteInfoHandler}>선택
                            </button>
                        </div>
                    </div>
                    <div className="nv_site">
                        <p className="nv_en">SINGAL</p>
                        <h2 className="nv_name">신갈연구소</h2>
                        <div className="site_select_wrap">
                            <div className="site_select">
                                <p className="selectTit">선택</p>
                                <ul>
                                    {
                                        site3.map((row2) => (
                                            <li onClick={() => setSelectSiteInfo(row2)}>{row2.name}</li>
                                        ))
                                    }
                                </ul>
                            </div>
                            <button type="button" className="btn_gate" onClick={changeSiteInfoHandler}>선택
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}